import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Strip static SEO defaults from index.html BEFORE React mounts so React 19's
// natively hoisted <title>/<meta>/<link> tags aren't duplicated. Non-JS
// crawlers still see the defaults in the initial HTML; JS clients see only
// the React-rendered per-route tags.
document.head
  .querySelectorAll('[data-static="true"]')
  .forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
